module.exports = __webpack_public_path__ + "media/images/dish-6-4bfb65041334e88a965268119e15911f.png";